import React from 'react';
import IconBase from './IconBase';

const ClassIcon = props => {
    return (
        <IconBase viewBox={'0 0 48 48'} {...props}>
            <path d="M28,36v-3h6v-2h4v2h3V14H7v19h2v3H7c-0.8,0-1.5-0.3-2.1-0.9S4,33.8,4,33V14c0-0.8,0.3-1.5,0.9-2.1S6.2,11,7,11h34c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1v19c0,0.8-0.3,1.5-0.9,2.1C42.5,35.7,41.8,36,41,36H28z"/>
            <path d="M18.5,23c-1.1,0-2-0.4-2.8-1.2c-0.8-0.8-1.2-1.7-1.2-2.8s0.4-2,1.2-2.8c0.8-0.8,1.7-1.2,2.8-1.2s2,0.4,2.8,1.2c0.8,0.8,1.2,1.7,1.2,2.8s-0.4,2-1.2,2.8C20.5,22.6,19.6,23,18.5,23z M12.6,27.4c1.2-1.3,5.9-1.2,5.9-1.2c2.8,0,5.4-0.1,8.2-0.4s5.5-0.7,8.2-1.3c0.5-0.1,0.9,0,1.3,0.2c0.4,0.2,0.7,0.6,0.8,1.1c0.1,0.4,0,0.9-0.2,1.3c-0.3,0.4-0.6,0.7-1,0.8c-1.9,0.4-3.8,0.7-5.8,1c-2,0.3-4.9,0.7-4.9,0.7V40H12V29.5C12,29.5,11.9,28.2,12.6,27.4z"/>
        </IconBase>
    )
}

export default ClassIcon;